var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "header",
        [
          _c("main-header", {
            attrs: { notificacao: false, hasListagemModelo: false }
          })
        ],
        1
      ),
      _c("div", { staticClass: "content-route-view" }),
      _vm.alterarPerfil
        ? _c("app-modal-alterar-perfil", {
            attrs: { cpfCnpj: _vm.usuarioSelecionado.cpfCnpj },
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _vm.bloquearUsuario
        ? _c("app-modal-bloquear-usuario", {
            attrs: {
              usuario: _vm.usuarioSelecionado,
              isBloqueio: _vm.isBloqueio
            },
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _vm.historicoUsuario
        ? _c("app-modal-historico-alteracao-usuario", {
            attrs: { idUsuario: _vm.usuarioSelecionado.id },
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _vm.visualizarUsuario
        ? _c("app-modal-visualizar-usuario", {
            attrs: { usuario: _vm.usuarioSelecionado },
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _vm.showModalAssinaturaToken
        ? _c("app-modal-assinatura-token", {
            attrs: { usuario: _vm.usuarioSelecionado },
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card margin-bottom", attrs: { shadow: "hover" } },
        [
          _vm.isPesquisaSimples
            ? _c("h1", [_vm._v("Pesquisa simplificada")])
            : _c("h1", [_vm._v("Pesquisa avançada")]),
          _c("app-search-usuarios", {
            on: {
              simpleSearch: _vm.simpleSearch,
              advancedInput: _vm.advancedSearch,
              clear: _vm.resetSearch,
              tipoPesquisaChanged: _vm.handleTipoPesquisaChanged
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card", attrs: { shadow: "hover" } },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("h1", [_vm._v("Usuários cadastrados")])
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "button" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.novoCadastro }
                      },
                      [
                        _c("span", { staticClass: "center" }, [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _c("span", [_vm._v("  Cadastrar")])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("app-divider", {
            attrs: { label: "Listagem de usuários cadastrados" }
          }),
          _c(
            "el-row",
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.usuarios,
                    "empty-text":
                      "Não foram encontrados usuários com os dados informados"
                  },
                  on: { "sort-change": _vm.changeOrder }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      label: "Situação",
                      prop: "situacao",
                      sortable: "sortable"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  placement: "left",
                                  content: _vm.formatSituacao(scope.row)
                                }
                              },
                              [
                                _c("div", [
                                  scope.row.bloqueado
                                    ? _c("i", { staticClass: "fa fa-ban" })
                                    : !scope.row.ativo
                                    ? _c("i", { staticClass: "fa fa-minus" })
                                    : _c("i", {
                                        staticClass: "fa fa-check ativo"
                                      })
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      label: "Assinatura/Token",
                      sortable: "sortable"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  placement: "left",
                                  content: _vm.formatAssinaturaToken(scope.row)
                                }
                              },
                              [
                                _c("div", [
                                  scope.row.assinaturaSimbolica &&
                                  scope.row.tokenPath !== ""
                                    ? _c(
                                        "i",
                                        { staticClass: "ativo material-icons" },
                                        [_vm._v("done_all")]
                                      )
                                    : (scope.row.assinaturaSimbolica &&
                                        scope.row.tokenPath === "") ||
                                      (!scope.row.assinaturaSimbolica &&
                                        scope.row.tokenPath !== "")
                                    ? _c("i", {
                                        staticClass: "fa fa-check ativo"
                                      })
                                    : _c("i", { staticClass: "fa fa-minus" })
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nomeRazaoSocial",
                      align: "left",
                      label: "Nome/Razão Social",
                      sortable: "sortable"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "email",
                      align: "left",
                      label: "E-mail",
                      sortable: "sortable"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cpfCnpj",
                      align: "center",
                      label: "CPF/CNPJ"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "perfis", align: "left", label: "Perfis" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "lista" },
                              _vm._l(
                                scope.row.perfis
                                  ? scope.row.perfis.split(",")
                                  : [],
                                function(perfil) {
                                  return _c("ul", [
                                    _c("li", [_vm._v(_vm._s(perfil))])
                                  ])
                                }
                              ),
                              0
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Ações", width: "120", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-dropdown",
                              { attrs: { trigger: "click" } },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "primary", size: "mini" } },
                                  [
                                    _vm._v("Ações"),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right"
                                    })
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.modalVisualizar(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-eye"
                                          }),
                                          _vm._v("  Visualizar")
                                        ]
                                      )
                                    ]),
                                    !scope.row.bloqueado
                                      ? _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.editarUsuario(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-pencil-alt"
                                              }),
                                              _vm._v("  Editar")
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    !scope.row.bloqueado
                                      ? _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.modalAlterarPerfil(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-user-circle"
                                              }),
                                              _vm._v("  Alterar Perfil")
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    !scope.row.bloqueado
                                      ? _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.redefinirSenha(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-key"
                                              }),
                                              _vm._v("  Redefinir Senha")
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    !scope.row.bloqueado &&
                                    _vm.usuarioLogado.id !== scope.row.id &&
                                    scope.row.ativo
                                      ? _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.modalBloquear(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-ban"
                                              }),
                                              _vm._v("  Bloquear")
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    scope.row.bloqueado &&
                                    !scope.row.ativo &&
                                    !_vm.isUsuarioLogado(scope.row)
                                      ? _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.modalDesbloquear(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-unlock-alt"
                                              }),
                                              _vm._v("  Desbloquear")
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.historicoAlteracaoUsuario(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-history"
                                          }),
                                          _vm._v("  Histórico")
                                        ]
                                      )
                                    ]),
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.getInfoAssinaturaToken(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-pencil-alt"
                                          }),
                                          _vm._v("  Assinatura/Token")
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("app-paginacao", {
                attrs: { total: _vm.total, pagina: _vm.paginaAtual },
                on: { changePage: _vm.changePage }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e795c15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e795c15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/AdministradorAcesso.vue
// module id = null
// module chunks = 